// @ts-nocheck
class UserInfo {
    username: string = ""
    email: string = ""
    roles: string[] = [] // TODO use an enum
    lastLogin: number = NaN

    constructor(
        username?: string,
        email?: string,
        roles?: string[], // TODO use an enum
        lastLogin?: number,
    ) {
        if (username) this.username = username
        if (email) this.email = email
        if (roles) this.roles = roles
        if (lastLogin) this.lastLogin = lastLogin
    }
}

export default UserInfo